import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const iqrDescription: CalculatorDescription = {
  title: 'Interquartile Range (IQR) Calculator',
  metaTitle: 'Online IQR Calculator - Calculate Interquartile Range',
  description: 'Calculate the interquartile range (IQR) and identify outliers in your data. Perfect for understanding data spread and detecting unusual values.',
  metaDescription: 'Calculate interquartile range online. Find Q1, Q3, and identify outliers with our free IQR calculator. Statistical analysis made easy.',
  howTo: {
    title: 'How to Calculate Interquartile Range',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically compute Q1, Q3, and the IQR values',
      'View the outlier analysis to identify unusual values in your dataset',
      'Examine the visualization to understand the spread and distribution of your data'
    ]
  },
  examples: [
    {
      title: 'Test Scores Analysis',
      description: 'Analyze the spread of test scores and identify unusually high or low scores.',
      dataDescription: 'Sample test scores: 45, 65, 70, 75, 80, 85, 90, 95, 100',
      insights: [
        'Middle 50% of scores fall between Q1 and Q3',
        'IQR shows the spread of the central data',
        'Outliers indicate unusually high or low performance',
        'Distribution shape reveals scoring patterns'
      ]
    }
  ],
  id: CalculatorId.INTERQUARTILE_RANGE,
  relatedCalculators: [
    CalculatorId.FIVE_NUMBER_SUMMARY,
    CalculatorId.BoxPlot,
    CalculatorId.STANDARD_DEVIATION
  ]
}; 